<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:class="headerClasses"
  >
    <div
      class="container-fluid d-flex align-items-right justify-content-between"
    >
      <!-- begin:: Header Menu -->
      <div
        class="header-menu-wrapper header-menu-wrapper-left col p-0 align-self-center"
        ref="kt_header_menu_wrapper"
      >
        <div class="row align-items-center">
          <div class="col-auto">
            <h6
              class="mb-0 font-weight-bolder align-items-center"
              v-blur-sensitive
              v-html="currentUserPersonalInfo.cliente"
            ></h6>
            <p
              class="mb-0"
              v-if="currentUserPersonalInfo.conta"
              v-b-tooltip.html="
                dadosMascarados
                  ? 'Código da conta oculto enquanto os dados estão protegidos'
                  : currentUserPersonalInfo.conta_id
              "
            >
              <span v-blur-sensitive class="font-weight-bolder">
                @{{ currentUserPersonalInfo.conta }}
              </span>
            </p>
            <p class="mb-0" v-if="currentUserPersonalInfo.emailCliente">
              <span class="font-weight-bolder">Email:</span>
              <span v-blur-sensitive>
                {{ currentUserPersonalInfo.emailCliente }}
              </span>
            </p>
          </div>

          <div
            class="col-auto"
            v-if="
              (checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 1
            "
          >
            <div class="d-flex">
              <button
                @click="trocarUsuarioOuConta"
                class="btn btn-wellon-branco btn-sm"
                :disabled="telaBloqueada"
                :title="telaBloqueada ? 'Tela bloqueada' : ''"
              >
                <i class="fas fa-arrows-to-dot"></i>
                Central de Contas
              </button>
              <!-- Cobrir e um clique; revelar pede o codigo do segundo fator
              quando o motor esta ligado. O rotulo segue `dadosMascarados`, e
              nao o botao, porque com o motor ligado o dado ja chega coberto
              mesmo sem ninguem ter clicado em nada. -->
              <button
                v-if="hasPermission('modo-apresentacao')"
                @click="togglePresentation"
                class="btn btn-wellon-branco btn-sm ml-3"
                :class="{ active: dadosMascarados }"
                :disabled="telaBloqueada"
                :title="
                  telaBloqueada
                    ? 'Tela bloqueada'
                    : dadosMascarados
                    ? 'Dados protegidos'
                    : 'Modo Apresentação'
                "
              >
                <i
                  :class="dadosMascarados ? 'fas fa-eye-slash' : 'fas fa-eye'"
                ></i>
                {{ dadosMascarados ? "Exibir dados" : "Ativar Apresentação" }}
              </button>
              <button
                @click="alternarBloqueioTela"
                class="btn btn-wellon-branco btn-sm ml-3"
                :title="telaBloqueada ? 'Tela bloqueada' : 'Bloquear tela'"
              >
                <i
                  :class="
                    telaBloqueada
                      ? 'fas fa-fingerprint'
                      : 'fas fa-unlock-keyhole'
                  "
                ></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end:: Header Menu -->

      <KTTopbar></KTTopbar>
    </div>

    <central-contas ref="centralContas"></central-contas>
    <modal-verificacao-acao ref="verificacaoAcao"></modal-verificacao-acao>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import Swal from "sweetalert2";
import ApiService from "@/core/services/api.service";
import CentralContas from "@/view/pages/painel/conta/central/CentralContas.vue";
import ModalVerificacaoAcao from "@/view/components/ModalVerificacaoAcao.vue";
import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";

export default {
  name: "KTHeader",
  components: {
    KTTopbar,
    "central-contas": CentralContas,
    "modal-verificacao-acao": ModalVerificacaoAcao
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");
  },
  computed: {
    ...mapGetters([
      "getClasses",
      "currentUserPersonalInfo",
      "isAccountAdmin",
      "contasParaTroca",
      "checkSuperAdmin",
      "isPresentationMode",
      "dadosMascarados",
      "anonimizacaoAtiva",
      "anonimizacaoLiberada",
      "hasPermission",
      "telaBloqueada"
    ]),

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  },

  methods: {
    ...mapActions(["togglePresentationMode", "setPresentationMode"]),

    /**
     * WEL-5344: cobrir é grátis, descobrir é que custa.
     *
     * A assimetria é o recurso, e ela inverte o que existia antes: o mesmo
     * alerta aparecia nos dois sentidos, e tirar a proteção era tão fácil
     * quanto colocá-la. Agora mascarar é um clique sem pergunta nenhuma, e
     * revelar exige o código do segundo fator, com validade e auditoria.
     */
    togglePresentation() {
      if (!this.dadosMascarados) {
        return this.alternarMascara(true);
      }

      // Já liberado no servidor e coberto só pelo botão: descobrir é local.
      if (!this.anonimizacaoAtiva || this.anonimizacaoLiberada) {
        return this.alternarMascara(false);
      }

      return this.liberarAnonimizacao();
    },

    /**
     * Troca o estado e RECARREGA, sempre.
     *
     * Sem a recarga o dado que já está na tela permanece como veio: ele foi
     * buscado sob o cabeçalho anterior, e o servidor é quem aplica a máscara.
     * O usuário clicaria em exibir e continuaria vendo os asteriscos, achando
     * que o botão não funcionou. Era o que a versão anterior fazia, e eu tinha
     * perdido isso ao reescrever o método.
     */
    alternarMascara(mascarar) {
      return Promise.resolve(this.setPresentationMode(mascarar)).then(() =>
        window.location.reload()
      );
    },

    /**
     * Pede o código do segundo fator e libera por 48h. A recarga é necessária
     * porque os dados já em tela vieram mascarados do servidor: sem ela o
     * usuário liberaria e continuaria vendo a máscara, achando que falhou.
     */
    async liberarAnonimizacao() {
      const codigo = await this.$refs.verificacaoAcao.abrir(
        "Exibir os dados reais",
        "Os dados de pacientes e da conta estão protegidos. A liberação vale " +
          "por 48 horas, é registrada na auditoria e volta a valer a cada novo acesso."
      );

      if (!codigo) {
        return;
      }

      try {
        const { data } = await ApiService.post("liberar-anonimizacao", {
          codigo
        });

        this.$store.dispatch(UPDATE_PERSONAL_INFO, {
          ...this.currentUserPersonalInfo,
          ...data.data
        });

        this.setPresentationMode(false);
        window.location.reload();
      } catch (erro) {
        Swal.fire({
          icon: "error",
          title: "Código inválido",
          text: "Confira o código atual e tente novamente.",
          heightAuto: false
        });
      }
    },

    // WEL-5192: bloqueio de tela pessoal. Só bloqueia (desbloqueio acontece
    // pelo formulário do LockOverlay, com o código do autenticador).
    alternarBloqueioTela() {
      if (this.telaBloqueada) {
        return;
      }

      if (this.currentUserPersonalInfo.canal_2fa !== "A") {
        Swal.fire({
          icon: "info",
          title: "Ative o aplicativo autenticador",
          text: "Para usar o bloqueio de tela, habilite o autenticador por app no seu perfil.",
          heightAuto: false
        });
        return;
      }

      ApiService.post("bloquear-tela").then(() => {
        this.$store.dispatch(UPDATE_PERSONAL_INFO, {
          ...this.currentUserPersonalInfo,
          tela_bloqueada: true
        });
      });
    },

    // Delegado ao componente CentralContas (extraído do Header): mantém o
    // mesmo gatilho de clique de sempre, só que agora abrindo o modal via ref
    // em vez de gerenciar o estado da lista aqui.
    trocarUsuarioOuConta() {
      this.$refs.centralContas.abrir();
    }
  }
};
</script>
